<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <!-- <v-col cols="12" sm="2" md="2" lg="2">
        <v-btn small outlined elevation="0" @click="downloadExcel">
          <v-icon>mdi-file-download-outline</v-icon>
        </v-btn>
      </v-col> -->
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="accounts" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) || "N/A" }}
              </template>
              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{
                          copiedStates[item.id]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.accounts="{ item }">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ item?.accounts?.fullname }}{{ "(" + item.client_account_id + ")" }}
                </router-link>
              </template>
              <template v-slot:item.leverage="{ item }">
                {{ 1 + ":" + item.leverage }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEMOACCOUNTS__ACTIONS } from "@/store/action-types";
import * as XLSX from "xlsx";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      isCopied: false,
      copiedStates: {},
      headers: [
        { text: "Reg. Time", align: "start", value: "created_at" },
        { text: "Acc No", value: "trading_account_no" },
        { text: "Name", value: "accounts" },
        { text: "Email", value: "email" },
        { text: "Reference No", value: "reference_no" },
        { text: "Leverage", value: "leverage" },
        { text: "Currency", value: "currency_name" },
      ],
    };
  },
  computed: {
    ...mapState("demoaccounts", ["accounts", "pagination", "isLoading"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    formatMySQLDate,
    ...mapActions("demoaccounts", [DEMOACCOUNTS__ACTIONS.DEMOACCOUNTS]),

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const apiData = this.accounts;

      const modifiedData = apiData.map((item) => ({
        "USER ID": item.client_account_id,
        NAME: item?.accounts?.fullname,
        EMAIL: item.email,
        "REGISTERED AT": item.created_at,
        PASSWORD: item.password,
        "INVESTOR PASSWORD": item.investor_password,
        LEVERAGE: item.leverage,
        DEPOSIT: item.deposit || "N/A",
      }));

      const ws = XLSX.utils.json_to_sheet(modifiedData);
      XLSX.utils.book_append_sheet(wb, ws, "Demo Accounts");
      const totalRow = modifiedData.length + 2;

      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "demo_accounts.xlsx");
    },

    async fetchData() {
      const params = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      await this[DEMOACCOUNTS__ACTIONS.DEMOACCOUNTS](params);
    },


    async handleSearch() {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>
